import React, { useEffect, useRef, useState } from "react";
import "./OrbitIntelChatComponent.css";
import { GetOktaAuthData, GetUserId } from "../../Utils/Utils";
import plusnewchat from "../../Assets/plusnewchat.svg";
import DisclaimerModal from "./DisclaimerModal";
import mbicon from "../../Assets/mb-sidebar-orbit.svg";
import MbSliderOrbitIntelChat from "./MbSliderOrbitIntelChat";
import ChatInterface from "./chat/ChatInterface";

const OrbitIntelChatComponent = () => {
  const user = GetOktaAuthData();
  const userId = GetUserId();
  const userProfileData = user?.user?.profile;

  const [inputDisabled, setInputDisabled] = useState(false);

  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [openSlide, setOpenSlide] = useState(false);
  const [hasMessages, setHasMessages] = useState(false);
  const chatRef = useRef(null);

  const onNewChat = () => setHasMessages(false);
  const handleNewChat = () => chatRef.current?.newChat();

  return (
    <div className="orbit-chat-main-start">
    <div className="orbit-chat-heading-video">
      <p
        className="Heading-inner-head"
        style={inputDisabled ? { pointerEvents: "none", opacity: 0.5 } : {}}
        onClick={handleNewChat}
      >
        <img src={plusnewchat} alt="" />
        New Chat
      </p>
    </div>

      <MbSliderOrbitIntelChat
        openSlide={openSlide}
        setOpenSlide={setOpenSlide}
        inputDisabled={inputDisabled}
        plusnewchat={plusnewchat}
        checked={false}
        handleNewChatNormal={handleNewChat}
        handleNewChatDeep={handleNewChat}
        setIsFeedbackOpen={() => {}}
      />

      <ChatInterface
        ref={chatRef}
        userId={userId}
        userProfileData={userProfileData}



        inputDisabled={inputDisabled}
        setInputDisabled={setInputDisabled}
        handleOpenDisclaimer={() => setShowDisclaimer(true)}
        onNewChat={onNewChat}
      />

      <DisclaimerModal
        open={showDisclaimer}
        onClose={() => setShowDisclaimer(false)}


      />
    </div>
  );
};

export default OrbitIntelChatComponent;
